import { Component, Input, inject } from '@angular/core';
import { EnvironmentService } from 'src/app/core/environment.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [],
})
export class LoaderComponent {
  env = inject(EnvironmentService);

  @Input() relativePosition = false;
  @Input() noMobileDisplay = false;
}
